import React from 'react';

import clsx from 'clsx';

import { Box } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { notificationBadge } from '../theme/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    countBadge: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: 20,
      height: 20,
      padding: '0 6px',
      borderRadius: 10,
      fontSize: 12,
      fontWeight: 600,
      backgroundColor: theme.palette.action.selected,
      color: theme.palette.text.secondary,
    },
    countBadgeActive: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.getContrastText(theme.palette.primary.main),
    },
    countBadgeNotification: {
      backgroundColor: notificationBadge.background,
      color: notificationBadge.text,
    },
  })
);

interface Props {
  title: string;
  count: number;
  /** Tint the badge with the primary colour, e.g. for the selected tab */
  active?: boolean;
  /** Paint the badge notification red: the count is something waiting for the user, e.g. unread messages */
  notification?: boolean;
}

/** Tab label with a selection counter; the badge is hidden while the count is zero. */
export const TabCountLabel: React.FC<Props> = ({ title, count, active = false, notification = false }) => {
  const classes = useStyles();

  return (
    <Box display="flex" alignItems="center" gridGap={8}>
      {title}
      {count > 0 && (
        <span
          className={clsx(classes.countBadge, {
            [classes.countBadgeActive]: active && !notification,
            [classes.countBadgeNotification]: notification,
          })}
        >
          {count}
        </span>
      )}
    </Box>
  );
};
